import { render, staticRenderFns } from "./MapPrototype.vue?vue&type=template&id=68776e78&scoped=true&"
import script from "./MapPrototype.vue?vue&type=script&lang=js&"
export * from "./MapPrototype.vue?vue&type=script&lang=js&"
import style0 from "./MapPrototype.vue?vue&type=style&index=0&id=68776e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68776e78",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QCardSection,QSeparator,QBtn,QSpace,QScrollArea,QTooltip,QSkeleton,QDialog,QRadio});
